






















































import {Mutation} from 'vuex-module-decorators';
import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import contentsModule from '@/model/store/modules/contents-module';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import detailModule from '@/model/store/modules/detail-module';
import viewerService from '@/model/services/viewer-service';
import contentsService from '@/model/services/contents-service';
import userService from '@/model/services/user-service';
import {GlobalAuthority, AuthorityNum} from '@/common/authority';
import {GCICategoryInfoRes, GCIContentsListRes, GCICategoryListRes, GCIContentsInfoRes, GCIFeedbackInContentsListRes} from '@/model/dto/res/contents/get-category-list-res';
import {PUCDataReq, PostUpsertContentsReq} from '@/model/dto/req/contents/post-upsert-contents-req';
import {PUICDataReq, PostUploadImageContentsReq} from '@/model/dto/req/contents/post-upload-image-contents-req';
import {CategoryInfoInterface} from '@/model/interfaces/category-interface';
import { VueEditor, Quill } from 'vue2-editor';
import { ImageDrop } from 'quill-image-drop-module';
import ImageResize from 'quill-image-resize-module';
import Compressor from 'compressorjs';
import {GlobalConstants} from '@/common/constants';
import {UserDataOnSessionStorageDataInterface, UserDataOnSessionStorageInterface} from '@/model/interfaces/user-interface';
import _ from 'lodash';

@Component({
  components: {
    'vue-editor': VueEditor
  }
})
export default class LoginViewer extends Vue {
  /** Data **/
  private time: number = 1000;
  private rules = {
    required: (value: string) => !!value || this.text.required,
    min: (v: string) => v.length >= this.text.minValue || this.text.minText,
    max: (v: string) => v.length <= this.text.maxValue || this.text.maxText,
    regex: (v: string) => {
      const check = /^[a-zA-Z]+[0-9]*$/.test(v) || this.text.regex;
      return check;
    }
  };
  private id: string = ''; // imymeleo0403@gmail.com
  private password: string = '';

  /** Computed **/
  get categoryInfo() {
    return appModule.categoryInfo;
  }

  get contents() {
    return detailModule.contents;
  }

  get userType() {
    return userModule.type;
  }

  get isAuthorityNumber() {
    return userService.isAuthorityNumber(userModule.type);
  }

  get Learner() {
    return AuthorityNum.Learner;
  }

  get userId() {
    return userModule.userId;
  }

  get userName() {
    return userModule.userName;
  }

  get login() {
    return appModule.loginData;
  }

  get token() {
    return appModule.token;
  }

  get isLogin() {
    return userModule.userId !== '' && appModule.token !== '';
  }

  set inputId(val: string) {
    this.id = val;
  }

  get inputId() {
    return this.id;
  }

  set inputPassword(val: string) {
    this.password = val;
  }

  get inputPassword() {
    return this.password;
  }

  get text() {
    return {
      title: GlobalConstants.TEXT.LOGINMANAGE.TITLE,
      label: GlobalConstants.TEXT.LOGINMANAGE.LABEL,
      key: GlobalConstants.TEXT.LOGINMANAGE.KEY,
      minValue: GlobalConstants.TEXT.LOGINMANAGE.MIN.VALUE,
      maxValue: GlobalConstants.TEXT.LOGINMANAGE.MAX.VALUE,
      minText: GlobalConstants.TEXT.LOGINMANAGE.MIN.TEXT,
      maxText: GlobalConstants.TEXT.LOGINMANAGE.MAX.TEXT,
      required: GlobalConstants.TEXT.LOGINMANAGE.REQUIRED,
      uniq: GlobalConstants.TEXT.LOGINMANAGE.UNIQ,
      regex: GlobalConstants.TEXT.LOGINMANAGE.REGEX,
      saveConfirmation: GlobalConstants.TEXT.LOGINMANAGE.SAVECONFIRMATION
    };
  }

  /** Methods **/
  private async onClickLogin() {
    const params = {
      userId: this.id, // '6e869d26'
      password: this.password // 'sudbb3c67a4df214b6fed885fbca55999'
    };
    await appModule.requestLoginInfo(params);
  }

  /** Watch **/
  @Watch('login')
  private async onLogin() {
    appModule.startLoading();
    await userService.requestUserInfo();

    if (this.isLogin) {
      setTimeout(() => {
        const path = `/`;
        this.$router.push({ path: `${path}`}).catch(err => err);
        appModule.stopLoading();
      }, 1000);
    } else {
      appModule.stopLoading();
    }

  }

  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

  /** LifeCycle **/
  private async beforeMount() {
    if (this.isLogin) {
      const path = `/`;
      this.$router.push({ path: `${path}`}).catch(err => err);
    }
  }

  private async mounted() {
    appModule.startLoading();
    // 初期queryのtokenをセット
    const strageData: UserDataOnSessionStorageInterface = JSON.parse(sessionStorage.getItem('undeux') || '{}');
    const token = this.$route.query.token ?? strageData.appModule.token;
    this.$router.push({path: `${this.$route.path}`}).catch(err => err);
    userService.requestUserInfo();
    appModule.stopLoading();
  }

}
